window.initProperties = () => {
    var $menuItems = $('#page-pegel,#page-talsperre,#page-wetter,#page-stadt,#page-gewaesser')
        .selectmenu({
            change: function (event, ui) {
                $('#page-title').val(ui.item.label);
                $('#page-path').val(ui.item.label);
            }
        })
        .data('ui-selectmenu');

    if ($menuItems) {
        $menuItems._renderItem = function (ul, item) {
            var li;
            if ($(item.element).attr('data-pageId') > -1) {
                li = $('<li class="cms-properties-disabled">').html(item.label);
            } else {
                li = $('<li>').html(item.label);
            }
            return li.appendTo(ul);
        };
    }

    $(
        '#page-parentId-button, #page-userId-button, #page-acv-button, #page-type-button, #page-pegel-button, #page-talsperre-button, #page-wetter-button, #page-stadt-button, #page-gewaesser-button'
    ).css({
        width: '100%'
    });

    // Resubmit neu setzen/l�schen
    $('.resubmit i').click(function (event) {
        var type = $(this).attr('data-type');
        var el = $(this).closest('li');
        $.ajax({
            cache: false,
            type: 'POST',
            url: '/Handler/HvD/Stammdaten',
            data: {
                action: 'resubmit',
                extra: $(this).attr('data-type'),
                id: $(this).attr('data-id'),
                mode: $(this).attr('data-action')
            }
        }).done(function (data) {
            if (data === 'ok') {
                el.remove();
                window.panes.reinitialise();
                $('.row.sticky .jspContainer').height($('.row.sticky .jspPane').height());
            }
        });
    });
};
initProperties();
